/**
 * @author Rejo Varghese
 * @description Modal body of Logs
 */
import React, { useState, useEffect } from 'react';
import './logs-modal.style.scss';
import { LOGS_CUSTOMER_DATA , LOGS_DROP_TIMINGS, LOGS_EDIT_FARE, LOGS_FOR_ADMIN_BLOCK_SEATS, LOGS_FOR_DRIVER_PH_NO_UPDATE, LOGS_FOR_RELEASE_SEATS, LOGS_PICK_UP_TIMINGS , LOGS_SEAT_FARE, LOGS_TRACKING_SMS_SENT, LOGS_MANAGEMENT_ALERT_SMS, LOGS_BUS_CHANGE, LOGS_FOR_VECHICLE_UPDATE, LOGS_FOR_EXCEPTIONAL_REFUND} from '../../../utils/constant';
import { Typography , Table, Row, Col} from 'antd';
import { getArrayfromString, isValid, isValidString, isValidArrayWithValues, isValidArray } from '../../../utils/utilities';
import { getFormattedTime, getLocalDateAndTime } from '../../../utils/date.utils';
import { isMobile } from 'react-device-detect';
import useColumnSearch from '../../../ui-components/table-column-search';
import { useDispatch, useSelector } from 'react-redux';
import { getBusDetailsAction } from '../../../actions/trip-create.actions';
import { tripCreateReducerSelector } from '../../../selector/trip-create.selector';
import { WhatsAppOutlined, MessageOutlined, MailOutlined, ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

const { Text } = Typography;

const ExpandedCustomerData = (props) => {
    const {
        selectedLog
    } = props;

    const rawData = selectedLog.rawData;
    const updateData = selectedLog.updatedData;
    const {travellers} = rawData;
    let travellerUpdate = updateData.travellers;

    const renderColumns = (row,text,key) => {

        if (isValid(travellerUpdate)&&isValid(travellerUpdate[row.traveller_id])&&isValid(travellerUpdate[row.traveller_id][`old_${key}`])) {
            let oldValue = null;
            if(isValid(travellerUpdate[row.traveller_id][`old_${key}`])){
                oldValue = travellerUpdate[row.traveller_id][`old_${key}`];
            }
            return (
                <div className="updateTableBorder">
                    {isValid(oldValue)?
                <>
                    <Text>From : {oldValue} To : {text}</Text>
                </>
                    :
                <Text>{text}</Text>
                }
                </div>
            )
        }
        else {
           return (<Text>{text}</Text>)
        }
    }

    const columns = [
        {
            title: "Seat no",
            dataIndex: "seat_number",
            key: "seat_number",
            render: (text,row) => {
                return renderColumns(row,text,"seat_number")
            }
        },
        {
            title: "Name",
            dataIndex: "full_name",
            key: "full_name",
            render: (text,row) => {
                return renderColumns(row,text,"full_name")
            }
        },
        {
            title: "Age",
            dataIndex: "age",
            key: "age",
            render: (text,row) => {
                return renderColumns(row,text,"age")
            }
        },
        {
            title: "Sex",
            dataIndex: "gender",
            key: "gender",
            render: (text,row) => {
                return renderColumns(row,text,"gender")
            }
        },
        {
            title: "Boarding",
            dataIndex: "pickup_location",
            key: "pickup_location",
            render: (text,row) => {
                return renderColumns(row,text,"pickup_location")
            }
        }
    ]

    return (
        <div>
            <Text style= {{fontWeight: 'bold'}}>PNR: {rawData.pnr}</Text>
            <br />
            <Text style= {{fontWeight: 'bold'}}>Phone: </Text>
            {isValid(updateData.phone_number)?<Text className = 'updateBox'>From : {updateData.old_phone_number} To : {updateData.phone_number}</Text>
            :<Text>{rawData.phone_number}</Text>}
            <br />
            <Text style= {{fontWeight: 'bold'}}>Email: </Text>
            {isValid(updateData.email_id)?<Text className = 'updateBox'>From : {updateData.old_email_id} To : {updateData.email_id}</Text>
            :<Text>{rawData.email_id}</Text>}
            <br />
            <Text style= {{fontWeight: 'bold'}}>Remarks: </Text>
            {isValid(updateData.remarks)?<Text className = 'updateBox'>From : {updateData.old_remarks} To : {updateData.remarks}</Text>
            :<Text>{rawData.remarks}</Text>}
            <br /><br />
            {isValidArrayWithValues(travellers)&&<Table
                dataSource={travellers}
                columns={columns}
                pagination={false}
                className="customer-data-table"
                bordered
                scroll={{
                    x: 400
                }}
                rowClassName={(record, index) => index % 2 === 1 ? 'alternating-row' : ''}
            />}
        </div>
    )
}

const CustomerData = (props) => {
    const {
        selectedLog
    } = props;

    const [expandedRowKeys, setExpandedRowKeys] = useState([]);

    const rawData = selectedLog.rawData;
    const parentColumns = [
        {
            title: 'Updated time',
            dataIndex: 'date',
            key: 'date',
            render:(text)=>{
                if(isValid(text)){
                    return `${getLocalDateAndTime(text)}`;
                }else{
                    return text
                }
            }
        },
        {
            title: 'Updated By',
            dataIndex: 'agent',
            key: 'agent',
        }
    ];

    const expandedRowRender = (record) => {
        return <ExpandedCustomerData selectedLog={record} />
    }

    const handleExpand = (expanded, record) => {
        if (expanded) {
            setExpandedRowKeys([record.key || record.date || record.agent]);
        } else {
            setExpandedRowKeys([]);
        }
    };

    // Ensure each row has a unique key
    const dataSourceWithKeys = isValidArray(rawData) ? rawData.map((item, index) => ({
        ...item,
        key: item.key || `${item.date}_${item.agent}_${index}`
    })) : [];

    return (
        <div>
            <Table
                dataSource={dataSourceWithKeys}
                columns={parentColumns}
                pagination={false}
                className="edit-fare-table"
                bordered
                expandable={{
                    expandedRowRender,
                    defaultExpandAllRows: false,
                    expandedRowKeys: expandedRowKeys,
                    onExpand: handleExpand
                }}
                scroll={isMobile ? { x: 400 } : null}
            />
        </div>
    )
}

const EditFareLog = (props) => {
    const {
        selectedLog,
        supportedFare,
        seatGroupIds
    } = props;

    const rawData = selectedLog.rawData;

    const fareJsonFields = selectedLog.fareJsonFields;

    // Group data by operation_time and user_name
    const groupedData = {};
    
    if (isValidArray(rawData)) {
        rawData.forEach(item => {
            const key = `${item.operation_time}_${item.user_name}`;
            if (!groupedData[key]) {
                groupedData[key] = {
                    operation_time: item.operation_time,
                    user_name: item.user_name,
                    routes: []
                };
            }
            groupedData[key].routes.push(item);
        });
    }

    // Convert grouped data to array
    const parentData = Object.values(groupedData).map((item, index) => ({
        ...item,
        key: index
    }));

    // Parent table columns - Updated time and Updated By
    const parentColumns = [
        {
            title: 'Updated time',
            dataIndex: 'operation_time',
            key: 'operation_time',
            render:(text)=>{
                if(isValid(text)){
                    return `${getLocalDateAndTime(text)}`;
                }else{
                    return text
                }
            }
        },
        {
            title: 'Updated By',
            dataIndex: 'user_name',
            key: 'user_name'
        }
    ];

    // Helper function to check if a fareJsonKey has any changes in the routes
    const hasChangesForFareKey = (routes, fareJsonKey) => {
        if (!isValidArray(routes)) return false;
        
        return routes.some(row => {
            let newFareValue = null;
            let oldFareValue = row.old_fare;

            if (isValidString(row.fare_json)) {
                try {
                    const fareJsonObject = JSON.parse(row.fare_json);
                    newFareValue = fareJsonObject[fareJsonKey];
                } catch (e) {
                    newFareValue = row.fare;
                }
            } else {
                newFareValue = row.fare;
            }

            if (isValidString(row.old_fare_json)) {
                try {
                    const oldFareJson = JSON.parse(row.old_fare_json);
                    oldFareValue = oldFareJson[fareJsonKey];
                } catch (e) {
                    // Keep oldFareValue as row.old_fare
                }
            }

            // Check if there's a change: both values exist and are different, or one is null and other is not
            const hasChange = isValid(newFareValue) && (newFareValue != oldFareValue);
            return hasChange;
        });
    };

    // Inner table columns - Origin-Destination and Fare fields
    const getInnerColumns = (routes) => {
        const columns = [
            {
                title: 'Origin-Destination',
                dataIndex: 'origin',
                key: 'origin',
                render: (text, row) => {
                    return (
                        <div>
                            {row.origin} - {row.destination}
                        </div>
                    )
                }
            }
        ];

        if(supportedFare === 1){
            columns.push({
                title: "Fare",
                dataIndex: 'fare',
                key: 'fare'
            });
        }

        if(isValidString(fareJsonFields)){
            // Separate SS_ fields from other fields
            const ssFields = [];
            const otherFields = [];
            
            fareJsonFields.forEach(fareJsonKey => {
                // Only consider fields that have changes
                if (hasChangesForFareKey(routes, fareJsonKey)) {
                    if (fareJsonKey.startsWith('SS_')) {
                        ssFields.push(fareJsonKey);
                    } else {
                        otherFields.push(fareJsonKey);
                    }
                }
            });

            // If there are SS_ fields, create a single combined column
            if (ssFields.length > 0) {
                // Extract seat numbers from SS_ fields (e.g., SS_1 -> 1, SS_2 -> 2)
                const seatNumbers = ssFields.map(key => key.substring(3)).join(', ');
                const firstSSField = ssFields[0]; // Use first SS_ field to get values (all have same values)

                columns.push({
                    title: `Seat # ${seatNumbers}`,
                    dataIndex: 'fare_json',
                    key: 'SS_combined',
                    render: (text, row) => {
                        let fareJsonObject = {};
                        if (isValidString(text)) {
                            fareJsonObject = JSON.parse(text);
                            text = fareJsonObject[firstSSField];
                        } else {
                            text = row.fare;
                        }
                        if (!isValid(text)) {
                            return <div>
                                No change
                            </div>
                        }
                        return <div>
                            <Row>
                                <Col style={{color: 'green'}}>New Fare: <span className="fontWeightBold">{text}</span></Col>
                            </Row>
                        </div>
                    }
                });
            }

            // Add other (non-SS_) fields as separate columns
            otherFields.forEach(fareJsonKey => {
                columns.push({
                    title: fareJsonKey,
                    dataIndex: 'fare_json',
                    key: fareJsonKey,
                    render: (text, row) => {
                        let fareJsonObject = {}, oldFare = row.old_fare, newFare = 0;
                        if (isValidString(text)) {
                            fareJsonObject = JSON.parse(text);
                            text = fareJsonObject[fareJsonKey];
                            let oldFareJson = row.old_fare_json;
                            if (isValidString(oldFareJson)) {
                                oldFareJson = JSON.parse(oldFareJson);
                                oldFare = oldFareJson[fareJsonKey];
                            }
                        } else {
                            text = row.fare;
                        }
                        if (!isValid(text) || text == oldFare) {
                            return <div>
                                No change
                            </div>
                        }

                        // Determine if fare increased or decreased
                        const fareIncreased = parseFloat(text) > parseFloat(oldFare);
                        const fareDecreased = parseFloat(text) < parseFloat(oldFare);
                        
                        return <div style={{display: 'flex', alignItems: 'stretch'}}>
                            {(fareIncreased || fareDecreased) && (
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginRight: '8px',
                                    fontSize: '28px',
                                    color: fareIncreased ? '#52c41a' : '#ff4d4f'
                                }}>
                                    {fareIncreased ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
                                </div>
                            )}
                            <div style={{flex: 1}}>
                                <Row>
                                    <Col style={{color: 'green'}}>
                                        New Fare: <span className="fontWeightBold">{text}</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col style={{color: 'red'}}>
                                        Old Fare: <span className="fontWeightBold">{oldFare}</span>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    }
                });
            });
        }

        return columns;
    };

    // Expandable row render
    const expandedRowRender = (record) => {
        return (
            <div className="edit-fare-nested-container">
                <Table
                    dataSource={record.routes}
                    columns={getInnerColumns(record.routes)}
                    pagination={false}
                    rowKey={(row, index) => `${row.origin}_${row.destination}_${index}`}
                    className="edit-fare-nested-table"
                    scroll={isMobile ? { x: 400 } : null}
                    rowClassName={(record, index) => index % 2 === 1 ? 'alternating-row' : ''}
                />
            </div>
        );
    };

    return (
        <div className="edit-fare-log-wrapper">
            <Table
                dataSource={parentData}
                columns={parentColumns}
                pagination={false}
                className="edit-fare-parent-table"
                expandable={{
                    expandedRowRender,
                    defaultExpandAllRows: false
                }}
                scroll={isMobile ? { x: 400 } : null}
            />
        </div>
    )
}


const PickupPointsLogs = (props) => {
    const {
        selectedLog
    } = props;

    const rawData = selectedLog.rawData;

    const columns=[
        {
            title: 'City',
            dataIndex: 'city',
            key: 'city',
            filters:selectedLog.cityFilters,
            onFilter: (value, record) => record.city.indexOf(value) === 0,
        },
        {
            title: 'Location',
            dataIndex: 'location',
            key: 'location',
            filters:selectedLog.locationFilters,
            onFilter: (value, record) => record.location.indexOf(value) === 0,
        },
        {
            title: 'Time',
            dataIndex: 'timing',
            key: 'timing',
            render:(text)=>{
                if(isValid(text)){
                    return `${getFormattedTime(text)}`;
                }else{
                    return text
                }
            }
        },
        {
            title: 'Updated time',
            dataIndex: 'operation_time',
            key: 'operation_time',
            render:(text)=>{
                if(isValid(text)){
                    return `${getLocalDateAndTime(text)}`;
                }else{
                    return text
                }
            }
        },
        {
            title: 'Updated By',
            dataIndex: 'updated_by',
            key: 'updated_by'
        }
    ];

  

    return (
        <div>
           <Table
                dataSource={rawData}
                columns={columns}
                pagination={false} 
                className="edit-fare-table"
                scroll={isMobile?{
                    x: 400
                }:null}
            />
        </div>
    )
}

const DropPointsLogs = (props) => {
    const {
        selectedLog
    } = props;

    const rawData = selectedLog.rawData;

    const columns=[
        {
            title: 'City',
            dataIndex: 'city',
            key: 'city',
            filters:selectedLog.cityFilters,
            onFilter: (value, record) => record.city.indexOf(value) === 0,
        },
        {
            title: 'Location',
            dataIndex: 'location',
            key: 'location',
            filters:selectedLog.locationFilters,
            onFilter: (value, record) => record.location.indexOf(value) === 0,
        },
        {
            title: 'Time',
            dataIndex: 'timing',
            key: 'timing',
            render:(text)=>{
                if(isValid(text)){
                    return `${getFormattedTime(text)}`;
                }else{
                    return text
                }
            }
        },
        {
            title: 'Updated time',
            dataIndex: 'operation_time',
            key: 'operation_time',
            render:(text)=>{
                if(isValid(text)){
                    return `${getLocalDateAndTime(text)}`;
                }else{
                    return text
                }
            }
        },
        {
            title: 'Updated By',
            dataIndex: 'updated_by',
            key: 'updated_by'
        }
    ];

  

    return (
        <div>
           <Table
                dataSource={rawData}
                columns={columns}
                pagination={false} 
                className="edit-fare-table"
                scroll={isMobile?{
                    x: 400
                }:null}
            />
        </div>
    )
}


const SeatFareLogs = (props) => {
    const {
        selectedLog
    } = props;

    const rawData = selectedLog.rawData;

    const columns=[
        {
            title: 'Origin',
            dataIndex: 'origin',
            key: 'origin',
            filters:selectedLog.cityFilters,
            onFilter: (value, record) => record.city.indexOf(value) === 0,
        },
        {
            title: 'Destination',
            dataIndex: 'destination',
            key: 'destination',
            filters:selectedLog.locationFilters,
            onFilter: (value, record) => record.location.indexOf(value) === 0,
        },
        {
            title: 'Seat No',
            dataIndex: 'seat_number',
            key: 'seat_number',
            ...useColumnSearch(
                {dataIndexExt:"seat_number"}
            ),
        },
        {
            title: 'Fare',
            dataIndex: 'fare',
            key: 'fare'
        },
        {
            title: 'Updated time',
            dataIndex: 'operation_time',
            key: 'operation_time',
            render:(text)=>{
                if(isValid(text)){
                    return `${getLocalDateAndTime(text)}`;
                }else{
                    return text
                }
            }
        },
        {
            title: 'Updated By',
            dataIndex: 'updated_by',
            key: 'updated_by'
        }
    ];

  

    return (
        <div>
           <Table
                dataSource={rawData}
                columns={columns}
                pagination={false} 
                className="edit-fare-table"
                scroll={isMobile?{
                    x: 400
                }:null}
            />
        </div>
    )
}

const ReleaseSeats = (props) => {
    const {
        selectedLog
    } = props;

    const rawData = selectedLog.rawData;

    const columns=[
        {
            title: 'Seat No',
            dataIndex: 'seat_number',
            key: 'seat_number',
            ...useColumnSearch(
                {dataIndexExt:"seat_number"}
            ),
        },
        {
            title: 'Updated time',
            dataIndex: 'operation_time',
            key: 'operation_time',
            render:(text)=>{
                if(isValid(text)){
                    return `${getLocalDateAndTime(text)}`;
                }else{
                    return text
                }
            }
        },
        {
            title: 'Updated By',
            dataIndex: 'user_name',
            key: 'user_name'
        }
    ];

  

    return (
        <div>
           <Table
                dataSource={rawData}
                columns={columns}
                pagination={false} 
                className="edit-fare-table"
                scroll={isMobile?{
                    x: 400
                }:null}
            />
        </div>
    )
}



const AdminBlockedSeats = (props) => {
    const {
        selectedLog
    } = props;

    const rawData = selectedLog.rawData;

    const columns=[
        {
            title: 'Seat No',
            dataIndex: 'seat_number',
            key: 'seat_number',
            ...useColumnSearch(
                {dataIndexExt:"seat_number"}
            ),
        },
        {
            title: 'Updated time',
            dataIndex: 'operation_time',
            key: 'operation_time',
            render:(text)=>{
                if(isValid(text)){
                    return `${getLocalDateAndTime(text)}`;
                }else{
                    return text
                }
            }
        },
        {
            title: 'Updated By',
            dataIndex: 'user_name',
            key: 'user_name'
        }
    ];

  

    return (
        <div>
           <Table
                dataSource={rawData}
                columns={columns}
                pagination={false} 
                className="edit-fare-table"
                scroll={isMobile?{
                    x: 400
                }:null}
            />
        </div>
    )
}


const DriverPhNoUpdate = (props) => {
    const {
        selectedLog
    } = props;

    const rawData = selectedLog.rawData;

    const columns=[
        {
            title: 'Phone Number',
            dataIndex: 'phone_no',
            key: 'phone_no',
            ...useColumnSearch(
                {dataIndexExt:"phone_no"}
            ),
        },
        {
            title: 'Updated time',
            dataIndex: 'operation_time',
            key: 'operation_time',
            render:(text)=>{
                if(isValid(text)){
                    return `${getLocalDateAndTime(text)}`;
                }else{
                    return text
                }
            }
        },
        {
            title: 'Updated By',
            dataIndex: 'updated_by',
            key: 'updated_by'
        }
    ];

  

    return (
        <div>
           <Table
                dataSource={rawData}
                columns={columns}
                pagination={false} 
                className="edit-fare-table"
                scroll={isMobile?{
                    x: 400
                }:null}
            />
        </div>
    )
}



const VechicleUpdateLogs = (props) => {
    const {
        selectedLog
    } = props;

    const rawData = selectedLog.rawData;

    const columns=[
        {
            title: 'Vechicle No',
            dataIndex: 'vechicle_no',
            key: 'vechicle_no',
            ...useColumnSearch(
                {dataIndexExt:"vechicle_no"}, true
            ),
        },
        {
            title: 'Updated time',
            dataIndex: 'operation_time',
            key: 'operation_time',
            render:(text)=>{
                if(isValid(text)){
                    return `${getLocalDateAndTime(text)}`;
                }else{
                    return text
                }
            }
        },
        {
            title: 'Updated By',
            dataIndex: 'updated_by',
            key: 'updated_by'
        }
    ];

    return (
        <div>
           <Table
                dataSource={rawData}
                columns={columns}
                pagination={false}
                className="edit-fare-table"
                scroll={isMobile?{
                    x: 400
                }:null}
            />
        </div>
    )
}

const ManagementAlertSMSLogs = (props) => {
    const {
        selectedLog
    } = props;

    const rawData = selectedLog.rawData;

    
    const columns=[
        {
            title: 'Phone Number',
            dataIndex: 'sent_phone',
            key: 'sent_phone',
            ...useColumnSearch(
                {dataIndexExt:"sent_phone"}, true
            ),
        },
        {
            title: 'SMS sent time',
            dataIndex: 'sending_time',
            key: 'sending_time',
            render:(text)=>{
                if(isValid(text)){
                    return `${getLocalDateAndTime(text)}`;
                }else{
                    return text
                }
            }
        },
        {
            title: 'Message Type',
            dataIndex: 'message_type',
            align: 'center',
            key: 'message_type',
            render: (text) => {
                if(isValid(text)&& text == 'Whatsapp'){
                    return <WhatsAppOutlined style={{color: '#46C256',textAlign: 'center'}}/>
                }else if(isValid(text)&& text == 'SMS'){
                    return <MessageOutlined style={{textAlign: 'center'}}/>
                }else if(isValid(text)&& text == 'Email'){
                    return <MailOutlined style={{textAlign: 'center'}}/>
                }else {
                    return text;
                }
            }
        },
        {
            title: 'Sent By',
            dataIndex: 'sent_by',
            key: 'sent_by'
        }
    ];

    return (
        <div>
           <Table
                dataSource={rawData}
                columns={columns}
                pagination={false}
                className="edit-fare-table"
                scroll={isMobile?{
                    x: 400
                }:null}
            />
        </div>
    )
}


const BusChangeLogs = (props) => {
    const {
        selectedLog
    } = props;

    const [busLogsData, setBusLogsData] = useState([]);

    const dispatch = useDispatch();
    const tripCreateReducer = useSelector(tripCreateReducerSelector);

    const {
        busesData
    } = tripCreateReducer;

    useEffect(() => {
        if (isValid(selectedLog)&& selectedLog.action === LOGS_BUS_CHANGE){
            dispatch(getBusDetailsAction());
        }
    }, [selectedLog]);

    const rawData = selectedLog.rawData;

    useEffect(() => {
        if(isValidArrayWithValues(busesData)&&isValidArrayWithValues(rawData)){
            let tempLogData = [];
            rawData.forEach(logData => {
                const oldBusData = busesData.find(bus => bus.id === logData.old_bus_id);
                const newBusData = busesData.find(bus => bus.id === logData.bus_id);
                tempLogData.push({...logData, old_bus_description: oldBusData.description, old_bus_total_seats: oldBusData.number_of_seats, new_bus_description: newBusData.description, new_bus_total_seats: newBusData.number_of_seats});
            });
            setBusLogsData(tempLogData.reverse());
        }
    }, [busesData, rawData]);


    const columns=[
        {
            title: 'Old Bus description',
            dataIndex: 'old_bus_description',
            key: 'old_bus_description',
        },
        {
            title: 'Old bus total seats',
            dataIndex: 'old_bus_total_seats',
            key: 'old_bus_total_seats',
        },
        {
            title: 'New bus description',
            dataIndex: 'new_bus_description',
            key: 'new_bus_description',
        },
        {
            title: 'New bus total seats',
            dataIndex: 'new_bus_total_seats',
            key: 'new_bus_total_seats',
        },
        {
            title: 'Updated time',
            dataIndex: 'operation_time',
            key: 'operation_time',
            render:(text)=>{
                if(isValid(text)){
                    return `${getLocalDateAndTime(text)}`;
                }else{
                    return text
                }
            }
        },
        {
            title: 'Updated By',
            dataIndex: 'updated_by',
            key: 'updated_by'
        }
    ];

    return (
        <div>
           <Table
                dataSource={busLogsData}
                columns={columns}
                pagination={false}
                className="edit-fare-table"
                scroll={isMobile?{
                    x: 400
                }:null}
            />
        </div>
    )


}

const ExceptionalRefundLogs = (props) => {
    const {
        selectedLog
    } = props;

    const rawData = selectedLog.rawData;

    const [exceptionalRefundData, setExceptionalRefundData] = useState([]);

    useEffect(() => {
        if(isValidArrayWithValues(rawData)){
            let tempData = [];
            rawData.forEach(logData => {
                let exceptionalObject = {'updated_by': logData.agent, 'operation_time': getLocalDateAndTime(logData.date), 'refund_value': logData.updatedData.refund_value, PNR: logData.rawData.pnr};
                let travellerIds = Object.keys(logData.updatedData.travellers);
                let seatNumbers = [];
                if(isValidArrayWithValues(logData.rawData.travellers)){
                    logData.rawData.travellers.forEach(traveller => {
                        if (travellerIds.includes(traveller.traveller_id.toString())){
                            seatNumbers.push(traveller.seat_number);
                        }
                    });
                }
                exceptionalObject['seat_numbers'] = seatNumbers.join(', ');
                tempData.push(exceptionalObject);
            });
            setExceptionalRefundData(tempData);
        }
    }, [rawData]);
    
    const columns=[
        {
            title: 'Update Time',
            dataIndex: 'operation_time',
            key: 'operation_time',
        },
        {
            title: 'PNR',
            dataIndex: 'PNR',
            key: 'PNR',
        },
        {
            title: 'Seat Numbers',
            dataIndex: 'seat_numbers',
            key: 'seat_numbers',
        },
        {
            title: 'Refund Amount',
            dataIndex: 'refund_value',
            key: 'refund_value',
        },
        {
            title: 'Updated by',
            dataIndex: 'updated_by',
            key: 'updated_by',
        },
    ];
    return (
        <div>
            <Table
                dataSource={exceptionalRefundData}
                columns={columns}
                pagination={false}
                className="edit-fare-table"
                scroll={isMobile?{
                    x: 400
                }:null}
            />
        </div>
    )
}


export const LogsModalBody = (props) => {
    const {
        selectedLog,
        supportedFare,
        seatGroupIds
    } = props;

    switch(selectedLog.action) {
        case LOGS_CUSTOMER_DATA:
            return <CustomerData selectedLog = {selectedLog} />

        case LOGS_EDIT_FARE:
            return <EditFareLog selectedLog = {selectedLog}  supportedFare={supportedFare} seatGroupIds={seatGroupIds}/>;

        case LOGS_PICK_UP_TIMINGS:
            return <PickupPointsLogs selectedLog = {selectedLog} />;
        
        case LOGS_DROP_TIMINGS:
            return <DropPointsLogs selectedLog = {selectedLog} />;

        case LOGS_SEAT_FARE:
            return <SeatFareLogs selectedLog = {selectedLog} />;
    
        case LOGS_FOR_RELEASE_SEATS:
            return <ReleaseSeats  selectedLog = {selectedLog}/>;

        case LOGS_FOR_ADMIN_BLOCK_SEATS:
            return <AdminBlockedSeats selectedLog = {selectedLog}/>;

        case LOGS_FOR_DRIVER_PH_NO_UPDATE:
                return <DriverPhNoUpdate selectedLog = {selectedLog}/>;

        case LOGS_FOR_VECHICLE_UPDATE:
            return <VechicleUpdateLogs selectedLog = {selectedLog}/>;

        case LOGS_FOR_EXCEPTIONAL_REFUND:
            return <ExceptionalRefundLogs selectedLog = {selectedLog}/>;
        // case LOGS_MANAGEMENT_ALERT_SMS:
        //     return <ManagementAlertSMSLogs selectedLog = {selectedLog} />;
        // case LOGS_TRACKING_SMS_SENT:
        //     return <TrackingSmsLogs selectedLog = {selectedLog}/>;

        case LOGS_BUS_CHANGE:
            return <BusChangeLogs selectedLog = {selectedLog}/>;

        default:            
            if(selectedLog.action_type === "Message"){
                return <ManagementAlertSMSLogs selectedLog = {selectedLog}/>;
            }
            return null;
    }
}